<template>
  <v-treeview
    :items="material.children"
    item-children="sources"
    multiple-active
    open-on-click
    open-all
  >
    <template v-slot:prepend="{ item }">
      <div v-if="item.barcode">
        <v-chip color="primary" dark>
          <v-icon left small>grain</v-icon>
          {{ item.barcode }}
        </v-chip>
      </div>
      <div v-else>
        <BatchNavigation :instance="item.batch"/>
      </div>
    </template>
    <template v-slot:label="{ item }">
      <div v-if="item.barcode">
        {{ item.name }}
      </div>
      <div v-else>
        {{ item.batch.name }}
      </div>
    </template>
  </v-treeview>
</template>

<script>
import BatchNavigation from "../../components/Batch/BatchNavigation";
export default {
  name: "MaterialBatches",
  components: { BatchNavigation },
  props: {
    material: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
};
</script>
